import { FC, useCallback } from "react";
import { useReactTable, getCoreRowModel } from "@tanstack/react-table";
import { useDispatch } from "react-redux";

import { ITableProps, TableCellValue, TableMetrics } from "./types";
import { setResponseModal } from "../../store/response/slice";
import TableHeader from "./components/TableHeader/TableHeader";
import TableCell from "./components/TableCell/TableCell";
import TableMobile from "./TableMobile";

import styles from "./Table.module.css";



const Table: FC<ITableProps> = ({ columns, data, brands, onChangeBrand }) => {
  const dispatch = useDispatch();
  
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const headerGroups = table.getHeaderGroups();
  const rows = table.getRowModel().rows;

  const onOpenResponse = useCallback(
    (responseId: string, metrics?: TableMetrics) => {
      dispatch(setResponseModal({ responseId, metrics }));
    },
    [dispatch]
  );

  return (
    <div className={styles['table-container']}>
      <div className={styles["table__desktop"]}>
        <table className={styles['table']}>
          <TableHeader headerGroups={headerGroups} brands={brands} onChangeBrand={onChangeBrand} />

          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <TableCell
                    key={cell.id}
                    cellId={cell.id}
                    columnId={cell.column.id}
                    value={(cell.getValue() as TableCellValue) || null}
                    onOpenResponse={onOpenResponse}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <TableMobile
        rows={rows}
        onOpenResponse={onOpenResponse}
      />
    </div>
  );
}

export default Table;